import React from "react";
import groupBy from "lodash.groupby";
import styled from "styled-components";
import { Body, spacing } from "@conserveit/blocks";
import { EquipList } from "../../Issues/components/IssuePane/IssuePane.styles";
import { EquipPreview } from "../../EquipPreview";

const RuleName = styled(Body)`
  margin-bottom: ${spacing.extraTight};
`;

const List = styled(EquipList)`
  margin-bottom: ${spacing.default};
  padding-left: 0;
`;
const ListItem = styled.li`
  margin-bottom: ${spacing.extraTight};
`;

const Field = styled.div`
  max-width: 400px;
  margin-bottom: ${spacing.default};
`;

interface Props {
  equips: Insite.API.ActionEquip[];
}

const EquipListField: React.FC<Props> = ({ equips }) => {
  const ruleGroups = groupBy(equips, (e) => e.ruleName);
  return (
    <Field>
      {Object.entries(ruleGroups).map(([key, val]) => (
        <React.Fragment key={key}>
          <RuleName>
            <strong>{key}</strong>
          </RuleName>
          <List>
            {val.map((equip) => (
              <ListItem key={equip.id}>
                <EquipPreview data={equip}>{equip.targetName}</EquipPreview>
              </ListItem>
            ))}
          </List>
        </React.Fragment>
      ))}
    </Field>
  );
};

export default React.memo(EquipListField);
